import * as actionTypes from '../types/zdvl';

export function getZDVL(payload) {
  return {
    type: actionTypes.GET_ZDVL,
    payload
  };
}
export function getZDVLSuccess(payload) {
  return {
    type: actionTypes.GET_ZDVL_SUCCESS,
    payload
  };
}
export function getZDVLFail(payload) {
  return {
    type: actionTypes.GET_ZDVL_FAIL,
    payload
  };
}

export function getZDVLAccept(payload) {
  return {
    type: actionTypes.GET_ZDVL_ACCEPT,
    payload
  };
}
export function getZDVLAcceptSuccess(payload) {
  return {
    type: actionTypes.GET_ZDVL_ACCEPT_SUCCESS,
    payload
  };
}
export function getZDVLAcceptFail(payload) {
  return {
    type: actionTypes.GET_ZDVL_ACCEPT_FAIL,
    payload
  };
}

export function getZDVLDecline(payload) {
  return {
    type: actionTypes.GET_ZDVL_DECLINE,
    payload
  };
}
export function getZDVLDeclineSuccess(payload) {
  return {
    type: actionTypes.GET_ZDVL_DECLINE_SUCCESS,
    payload
  };
}
export function getZDVLDeclineFail(payload) {
  return {
    type: actionTypes.GET_ZDVL_DECLINE_FAIL,
    payload
  };
}

export function getZDVLSend(payload) {
  return {
    type: actionTypes.GET_ZDVL_SEND,
    payload
  };
}
export function getZDVLSendSuccess(payload) {
  return {
    type: actionTypes.GET_ZDVL_SEND_SUCCESS,
    payload
  };
}
export function getZDVLSendFail(payload) {
  return {
    type: actionTypes.GET_ZDVL_SEND_FAIL,
    payload
  };
}

export function getZDVLClear(payload) {
  return {
    type: actionTypes.GET_ZDVL_CLEAR,
    payload
  };
}

export function getZDVLRolls(payload) {
  return {
    type: actionTypes.GET_ZDVL_ROLLS,
    payload
  };
}

export function getZDVLRollsSuccess(payload) {
  return {
    type: actionTypes.GET_ZDVL_ROLLS_SUCCESS,
    payload
  };
}

export function getZDVLRollsFail(payload) {
  return {
    type: actionTypes.GET_ZDVL_ROLLS_FAIL,
    payload
  };
}

export function tieZDVLRolls(payload) {
  return {
    type: actionTypes.TIE_ZDVL_ROLLS,
    payload
  };
}

export function tieZDVLRollsSuccess(payload) {
  return {
    type: actionTypes.TIE_ZDVL_ROLLS_SUCCESS,
    payload
  };
}

export function tieZDVLRollsFail(payload) {
  return {
    type: actionTypes.TIE_ZDVL_ROLLS_FAIL,
    payload
  };
}

export function ridZDVLRolls(payload) {
  return {
    type: actionTypes.RID_ZDVL_ROLLS,
    payload
  };
}

export function ridZDVLRollsFail(payload) {
  return {
    type: actionTypes.RID_ZDVL_ROLLS_FAIL,
    payload
  };
}

export function ridZDVLRollsSuccess(payload) {
  return {
    type: actionTypes.RID_ZDVL_ROLLS_SUCCESS,
    payload
  };
}

export function closeZDVL(payload) {
  return {
    type: actionTypes.CLOSE_ZDVL,
    payload
  };
}
export function closeZDVLSuccess(payload) {
  return {
    type: actionTypes.CLOSE_ZDVL_SUCCESS,
    payload
  };
}
export function closeZDVLFail(payload) {
  return {
    type: actionTypes.CLOSE_ZDVL_FAIL,
    payload
  };
}

export function setZDVLLineStatusData(payload) {
  return {
    type: actionTypes.SET_ZDVL_LINE_STATUS_DATA,
    payload
  };
}

export function updateZDVLModalClose(payload) {
  return {
    type: actionTypes.UPDATE_ZDVL_MODAL_CLOSE,
    payload
  };
}
export function updateZDVL(payload) {
  return {
    type: actionTypes.UPDATE_ZDVL,
    payload
  };
}
export function updateZDVLSuccess(payload) {
  return {
    type: actionTypes.UPDATE_ZDVL_SUCCESS,
    payload
  };
}
export function updateZDVLFail(payload) {
  return {
    type: actionTypes.UPDATE_ZDVL_FAIL,
    payload
  };
}
export function getZDVLSendNotice(payload) {
  return {
    type: actionTypes.GET_ZDVL_SEND_NOTICE,
    payload
  };
}
export function getZDVLSendNoticeSuccess(payload) {
  return {
    type: actionTypes.GET_ZDVL_SEND_NOTICE_SUCCESS,
    payload
  };
}
export function getZDVLSendNoticeFail(payload) {
  return {
    type: actionTypes.GET_ZDVL_SEND_NOTICE_FAIL,
    payload
  };
}